import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { TrainingsSettingsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import PageLoading from 'modules/layout/components/Page/Loading'
import { GlobalSettings } from 'modules/trainings/components/Settings/GlobalSettings'
import CollectionsBootstrap from 'modules/trainings/lib/SettingsCollectionsBootstrap'

const Container = () => {
  const { loading, data } = useQuery(TrainingsSettingsRootPageDocument)

  if (loading) {
    return (
      <Box width="full" height="full" justifyContent="center" alignItems="center">
        <PageLoading />
      </Box>
    )
  }

  return (
    <AuthorizeUser
      authorizeFn={() => data?.trainings?._policies?.sidebarSeeTrainingsTopLevelItem?.can ?? false}
    >
      <Outlet />
      <GlobalSettings />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
